import { getSignalTypeBundleWithoutScene } from "../models/SignalBundles";
import AddressGeneratorUtils from "./AddressGeneratorUtils";
import { descriptionForSignalType } from "../models/SignalTypes";

import GroupAddress from "../models/GroupAdress";
import Multiplexer from "../models/Multiplexer";
import { itx } from "../translationItx/itx";
import GroupAddressNameGenerator from "./GroupAddressNameGenerator";

function generateAddressesForMultiplexer_A_C(mainGroup: GroupAddress) {
  //
  // Im Schema "A" und "C" sind Multiplexer fix unter "31/7"
  //

  const middleGroup = AddressGeneratorUtils.getOrCreateGroupAddressByAddress({
    tag: "MX", // no itx
    name: "Multiplexer",
    level: 2,
    address: "7", // no itx
    parent: mainGroup,
  });

  state.sceneGroup.sortBy("tagOrName").forEach((multiplexer) => {
    if (multiplexer.className == "Multiplexer") {
      // no itx
      generateAddressesForMultiplexer_3(multiplexer as Multiplexer, middleGroup);
    }
  });
}

function generateAddressesForMultiplexer_B(mainGroup: GroupAddress) {
  //
  // Im Schema B sind Multiplexer auf der 2. Ebene unter der festen nummer 7
  //

  let consumerIndex = AddressGeneratorUtils.getAddressForChannelTypeLevel2("Multiplexer"); // From state  // no itx
  let consumerClassTag = AddressGeneratorUtils.getChannelTag("Multiplexer"); // Tag used on drawingArea / canvas  // no itx

  let middleGroup = AddressGeneratorUtils.getOrCreateGroupAddressByAddress({
    level: 2,
    tag: consumerClassTag,
    name: itx("components.Multiplexer", "Multiplexer"),
    address: `${consumerIndex}`,
    parent: mainGroup,
  });

  state.sceneGroup.sortBy("tagOrName").forEach((multiplexer) => {
    if (multiplexer.className == "Multiplexer") {
      // no itx
      generateAddressesForMultiplexer_3(multiplexer as Multiplexer, middleGroup);
    }
  });
}

function generateAddressesForMultiplexer_3(multiplexer: Multiplexer, middleGroup: GroupAddress) {
  //
  // All "CommandSignals" are created new for the multiplexer
  //
  const signalTypeBundle = getSignalTypeBundleWithoutScene(multiplexer.channelType);

  signalTypeBundle.forEach((signalType) => {
    if (!signalType.isStatus) {
      //
      // this is an ActionSignal of a Multiplexer...
      //
      //   This Signal is similar to an consumer signal and the generator of the one and only group address
      //
      var name3 =
        descriptionForSignalType(signalType) +
        " - " +
        itx("components.Multiplexer", "Multiplexer") +
        ": " +
        multiplexer.name;

      const multiplexerSignal = multiplexer.getOrCreateSignalByType(signalType);
      if (multiplexerSignal) {
        const name = state.settings.groupAddressNameGenerator.generateGroupAddressNameForMultiplexer(
          multiplexer,
          multiplexerSignal,
        );

        let groupAddress3 =
          multiplexerSignal?.groupAddresses.firstItem || multiplexerSignal?.lastGroupAddresses?.firstItem;

        if (groupAddress3) {
          middleGroup.children.addWithoutUpdate(groupAddress3);
          groupAddress3.name = name3;
        } else {
          groupAddress3 = GroupAddress.createNewGroupAddress({
            level: 3,
            name: `${name3}`,
            parent: middleGroup,
          });

          groupAddress3.generatorObject = multiplexer;
        }

        multiplexerSignal.addGroupAddress(groupAddress3);
      }
    }
  });
}

export function generateAddressesForMultiplexer(scheme: string, mainGroup: GroupAddress) {
  switch (scheme) {
    case "A":
    case "C":
      generateAddressesForMultiplexer_A_C(mainGroup);
      break;

    case "B":
      state.sceneGroup.sortBy("tagOrName").forEach((multiplexer) => {
        if (multiplexer.className == "Multiplexer") {
          // no itx
          generateAddressesForMultiplexer_B(mainGroup);
        }
      });
      break;
  }
}
